import { render, staticRenderFns } from "./AppInput.vue?vue&type=template&id=15c6210e&scoped=true&"
import script from "./AppInput.vue?vue&type=script&lang=js&"
export * from "./AppInput.vue?vue&type=script&lang=js&"
import style0 from "./AppInput.vue?vue&type=style&index=0&id=15c6210e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6210e",
  null
  
)

export default component.exports